import { render, staticRenderFns } from "./RevisarTareas.vue?vue&type=template&id=f1d88034&"
import script from "./RevisarTareas.vue?vue&type=script&lang=js&"
export * from "./RevisarTareas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports